<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-body">
      <canvas width="800" height="500"/>
    </div>

    <BreakdownModal :rows="breakdown"/>
  </div>
</template>

<script>
const totalizer = {
  id: 'totalizer',

  beforeUpdate: chart => {
    let totals = {}
    let utmost = 0

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (chart.isDatasetVisible(datasetIndex)) {
        utmost = datasetIndex

        dataset.data.forEach((value, index) => {
          totals[index] = (totals[index] || 0) + value
        })
      }
    })

    chart.$totalizer = {
      totals: totals,
      utmost: utmost
    }
  }
}

import moment from 'moment'
import Chart from 'chart.js'
import datalabels from 'chartjs-plugin-datalabels'
import BreakdownModal from './BreakdownModal'

export default {
  components: {BreakdownModal},

  props: {
    data: {
      required: true,
      type: Array
    },

    year: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      chart: null,

      month: null
    }
  },

  mounted() {
    this.draw()
  },

  watch: {
    data: {
      deep: true,
      handler: function () {
        this.draw()
      }
    }
  },

  computed: {
    months() {
      let startDate = moment().year(this.year).startOf('year')

      let endDate = moment().year(this.year).endOf('year')

      let result = []

      while (startDate.isBefore(endDate)) {
        result.push(startDate.format('MM/YYYY'))

        startDate.add(1, 'month')
      }

      return result
    },

    breakdown() {
      return this.data.filter(row => row.month === this.month)
    }
  },

  methods: {
    draw() {
      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(this.$el.querySelector('canvas').getContext('2d'), {
        plugins: [datalabels, totalizer],

        type: 'bar',

        data: {
          labels: this.months,
          datasets: [
            {
              label: 'Existing',
              data: this.months.map(month => this.data.filter(row => row.category === 'existing').filter(row => row.month === month).reduce((sum, row) => sum + row.value, 0)),
              backgroundColor: '#62d26f',
              borderColor: '#62d26f',
              fill: false
            },
            {
              label: 'Forecast',
              data: this.months.map(month => this.data.filter(row => row.category === 'forecast').filter(row => row.month === month).reduce((sum, row) => sum + row.value, 0)),
              backgroundColor: '#eec300',
              borderColor: '#eec300',
              fill: false
            },
            {
              label: 'New',
              data: this.months.map(month => this.data.filter(row => row.category === 'new').filter(row => row.month === month).reduce((sum, row) => sum + row.value, 0)),
              backgroundColor: '#20aaea',
              borderColor: '#20aaea',
              fill: false
            }
          ]
        },

        options: {
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
                callback: value => this.$options.filters.price(value)
              }
            }]
          },

          layout: {
            padding: {
              top: 25
            }
          },

          legend: {
            position: 'bottom'
          },

          plugins: {
            datalabels: {
              anchor: 'end',
              align: 'end',
              formatter: (value, ctx) => this.$options.filters.price(ctx.chart.$totalizer.totals[ctx.dataIndex]),
              display: (ctx) => ctx.datasetIndex === ctx.chart.$totalizer.utmost
            }
          },

          tooltips: {
            callbacks: {
              label: (t, d) => {
                return d.datasets[t.datasetIndex].label + ': ' + this.$options.filters.price(d.datasets[t.datasetIndex].data[t.index])
              }
            }
          },

          onClick: event => {
            if (this.chart.getElementAtEvent(event).length) {
              this.month = this.months[this.chart.getElementAtEvent(event)[0]._index]

              $('#forecast-breakdown-modal').modal('show')
            }
          }
        }
      })
    }
  }
}
</script>
